import { render, staticRenderFns } from "./Packlists.vue?vue&type=template&id=d573e35e&scoped=true"
import script from "./Packlists.vue?vue&type=script&lang=js"
export * from "./Packlists.vue?vue&type=script&lang=js"
import style0 from "./Packlists.vue?vue&type=style&index=0&id=d573e35e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d573e35e",
  null
  
)

export default component.exports